import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {WebshopRestService} from '../../services/api/webshop-rest.service';
import * as fromPromoActions from '../actions/promo.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {ProductsResponse} from '../../models/shop/products-response.model';
import {of} from 'rxjs/internal/observable/of';


@Injectable()
export class PromoEffects {
    private actions$ = inject(Actions);
    private productRestService = inject(WebshopRestService);

    loadPromo$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromPromoActions.PromoLoadAction>(
                fromPromoActions.PromoActionTypes.PROMO_LOAD
            ),
            map(action => action.payload),
            switchMap(productRequest =>
                this.productRestService.loadPromo().pipe(
                    switchMap(data => {
                        const resp = new ProductsResponse({ ...data.returnObject });
                        if (productRequest.page === 1) {
                            return [
                                new fromPromoActions.PromoLoadCompleteAction(resp),
                                new fromPromoActions.PromoBatchFromCache()
                            ];
                        } else {
                            return [new fromPromoActions.PromoLoadCompleteAction(resp)];
                        }
                    }),
                    catchError(error => of(new fromPromoActions.PromoLoadFailAction(error)))
                )
            )
        )
    );

    searchPromo$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromPromoActions.PromoSearchAction>(
                fromPromoActions.PromoActionTypes.PROMO_SEARCH
            ),
            map(action => action.payload),
            switchMap(request => [
                new fromPromoActions.PromoLoadAction(request)
            ])
        )
    );

}